import React from "react";
import Slider, { SliderSlide } from "components/Slider";

import { ComponentBackgroundColor } from "types/componentBackground";
import { useRemoteOffers } from "../../utils/useRemoteOffers";
import { WindowLocation } from "@reach/router";
import { useLanguage } from "../../utils/localization/languages/I18nContext";
import ErrorBoundary from "components/ErrorBoundary";
import OfferSliderCard from "../Card/OfferSliderCard";

interface OffersSliderProps {
  cardBackgroundColor?: ComponentBackgroundColor;
  location: WindowLocation;
}

const OffersSlider: React.FC<OffersSliderProps> = ({
  cardBackgroundColor,
  location
}) => {
  const language = useLanguage();
  const { data } = useRemoteOffers(language, location);

  return (
    <ErrorBoundary>
      <Slider
        variantColor={cardBackgroundColor}
        data-content-name="offers_slider"
      >
        {data &&
          data.map((item) => {
            return (
              <SliderSlide key={item.sanityId}>
                <OfferSliderCard
                  offer={item}
                  cardBackgroundColor={cardBackgroundColor}
                />
              </SliderSlide>
            );
          })}
      </Slider>
    </ErrorBoundary>
  );
};

export default OffersSlider;
